import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useIntl } from "react-intl";
import { dynamicMessage } from "translation";
export function TextInput({ label, helpBlock, meta, disabled, input, autoComplete, type }) {
    const intl = useIntl();
    let className = "is-valid";
    if (meta.touched || meta.submitFailed) {
        if (meta.invalid) {
            className = "is-invalid";
        }
    }
    if (disabled) {
        className = "disabled";
    }
    const errorMsg = (Boolean(meta.invalid) && dynamicMessage(intl, meta.error)) || "";
    let help = _jsx("div", { children: helpBlock });
    if (errorMsg !== "") {
        const feedback = _jsx("span", { className: "eduid-field-error", children: errorMsg });
        help = (_jsxs("div", { children: [feedback, " ", helpBlock && "|", " ", helpBlock] }));
    }
    return (_jsxs("div", { id: `${input.name}-wrapper`, className: "form-group form-wrapper", children: [label && (_jsx("label", { htmlFor: input.name, "aria-label": input.name, children: label })), _jsx("input", Object.assign({ id: input.name, className: `${className}`, type: type }, input, { disabled: disabled, autoComplete: autoComplete })), help] }));
}
